module.exports = __webpack_public_path__ + "media/images/pla/pla18-f9156ef15cad3381bb939dd52e38e55d.jpg";